import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import TagUpdatesAsideViewQuery, {
	type TagUpdatesAsideViewQuery as TagUpdatesAsideViewQueryType,
} from '../TagUpdatesView/__generated__/TagUpdatesAsideViewQuery.graphql';
import {
	SHOW_LIMIT,
	getActiveProjectsTql,
	getCompletedProjectsTql,
	getPausedProjectsTql,
	getPendingProjectsTql,
	getRelatedGoalsTql,
} from '../TagUpdatesView/getTqlQueries';

// TQL can underfetch with perms - adding a slight buffer to make sure we get the SHOW_LIMIT amount of items.
const TQL_OVERFETCH = 3;
export const tagUpdatesAsideResource: RouteResource<
	PreloadedQuery<TagUpdatesAsideViewQueryType, Record<string, unknown>>
> = createRelayResource<TagUpdatesAsideViewQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const uuid = routerContext?.match?.params.id ?? '';
		return {
			query: TagUpdatesAsideViewQuery,
			variables: {
				tagUUID: routerContext?.match?.params.id,
				workspaceUuid: context.workspace?.UUID || '',
				activeProjectsTql: getActiveProjectsTql(uuid),
				pendingProjectsTql: getPendingProjectsTql(uuid),
				pausedProjectsTql: getPausedProjectsTql(uuid),
				completedProjectsTql: getCompletedProjectsTql(uuid),
				relatedGoalsTql: getRelatedGoalsTql(uuid),
				sidebarLimit: SHOW_LIMIT + TQL_OVERFETCH,
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
